import { PropertyClient } from 'api/clients/PropertyClient'
import { SUCCESS_RESPONSE_TYPE } from 'api/constants'
import { useCurrentWorkspace } from 'hooks/useCurrentWorkspace'
import { useHideProperties } from 'hooks/useHideProperties'
import { isUndefined } from 'lodash'
import { defaultLongCacheTime } from 'queryClient'
import { useQuery } from 'react-query'
import { useDispatch } from 'react-redux'
import { upsertProperties } from 'redux/actions/properties'

export const useProperties = (
  queryParams: { [key: string]: any } = {},
  reactQueryOptions: any = {},
  { pushToStore = false }: { pushToStore?: boolean } = {},
) => {
  const workspace = useCurrentWorkspace()
  const dispatch = useDispatch()
  const hideProperties = useHideProperties()

  return useQuery(
    ['workspace', workspace?.key, 'properties', queryParams],
    async () => {
      // TODO: Fix this the next time the file is edited.
      // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
      const response = await PropertyClient.getProperties(workspace!.key, queryParams)
      if (pushToStore && response.type === SUCCESS_RESPONSE_TYPE) {
        const {
          data: { properties },
        } = response
        dispatch(upsertProperties(properties))
      }
      return response
    },
    {
      cacheTime: defaultLongCacheTime,
      ...reactQueryOptions,
      enabled: (isUndefined(reactQueryOptions.enabled) || reactQueryOptions.enabled) && !!workspace && !hideProperties,
      refetchOnWindowFocus: false,
      initialData: { type: SUCCESS_RESPONSE_TYPE, data: { properties: [] } },
    },
  )
}
